import React from 'react';
import PropTypes from 'prop-types';

const sourceLabel = (source) => source.title || source.domain || source.url || 'Source';

const GroundingFooter = ({ grounding }) => {
  const sources = grounding?.sources || [];
  if (sources.length === 0) return null;

  return (
    <div className="ai-chat-grounding-footer">
      <div className="ai-chat-grounding-sources" aria-label="Grounding sources">
        {sources.map((source, index) => (
          <a
            key={source.url || source.domain || source.title || `grounding-source-${index}`}
            className="ai-chat-grounding-source"
            href={source.url}
            title={source.url || sourceLabel(source)}
            target="_blank"
            rel="noreferrer"
          >
            {sourceLabel(source)}
          </a>
        ))}
      </div>
    </div>
  );
};

GroundingFooter.propTypes = {
  grounding: PropTypes.shape({
    sources: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
      domain: PropTypes.string,
    })),
  }),
};

GroundingFooter.defaultProps = {
  grounding: null,
};

export default GroundingFooter;
